import localforage from "localforage";

export function findLocalItem(storageItemName, key) {
  const value = JSON.parse(localStorage.getItem(storageItemName));
  let keyValue = null;

  if (value?.length > 0) {
    const keyIndex = value?.findIndex((k) => k[0] === key);
    if (keyIndex !== -1) {
      keyValue = value[keyIndex][1];
    }
  }
  return keyValue;
}

export const findLocalStorageItem = (storageItemName, key) => {
  let keyValue = null;

  return localforage.getItem(storageItemName).then((value) => {
    if (value?.length > 0) {
      const keyIndex = value?.findIndex((k) => k[0] === key);
      if (keyIndex !== -1) {
        keyValue = value[keyIndex][1];
      }
    }
    return keyValue;
  });
};

export const clearAllLocalStorageData = () => {
  localforage.clear();
  localStorage.clear();
};
